module.exports = __webpack_public_path__ + "static/img/novalloy-metal-micro-imaging-anodized-aluminum01.93f13b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/novalloy/novalloy-metal-micro-imaging-anodized-aluminum01.jpg
// module id = 783
// module chunks = 0